<script lang="ts" setup>
import Tag from "@/components/atoms/other/Tag.vue";

const props = defineProps({
  canCommuteByCar: {
    type: Boolean,
    required: true
  },
  canCommuteByBike: {
    type: Boolean,
    required: true
  },
  canCommuteByBicycle: {
    type: Boolean,
    required: true
  },
  canCommuteByPublicTransit: {
    type: Boolean,
    required: true
  }
});
function getTagClass(isActive: boolean) {
  return isActive ? "tag-yellow" : "tag";
}
</script>
<template>
  <div class="commute-method-tags">
    <Tag label="車" :class="getTagClass(props.canCommuteByCar)" />
    <Tag label="バイク" :class="getTagClass(props.canCommuteByBike)" />
    <Tag label="自転車" :class="getTagClass(props.canCommuteByBicycle)" />
    <Tag label="電車" :class="getTagClass(props.canCommuteByPublicTransit)" />
    <Tag label="バス" :class="getTagClass(props.canCommuteByPublicTransit)" />
    <Tag label="徒歩" :class="getTagClass(props.canCommuteByPublicTransit)" />
  </div>
</template>
<style lang="scss" scoped>
.commute-method-tags {
  display: flex;
  gap: 4px;
}

.tag {
  flex: 1 1 0;
  height: 30px;
  padding: 3px 5px;
  font-size: 12px;
  line-height: 16px;
  color: $gray-05;
  background-color: $gray-01;
  border: 1px solid $gray-03;
}

.tag-yellow {
  @extend .tag;

  color: $primary-dark;
  background-color: $light-yellow;
  border-color: $yellow;
}
</style>
